function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconColor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 32",
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#99c5f8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 8767"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3680",
    transform: "translate(22.511 20.063)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.568v1.046H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3681",
    transform: "translate(18.383 17.97)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.569v3.139H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3682",
    transform: "translate(14.256 15.877)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.569v5.233H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3683",
    transform: "translate(10.128 13.784)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.569v7.326H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3684",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.569v11.11H0z",
    transform: "translate(6 10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor1);
export default __webpack_public_path__ + "static/media/icon_color1.e1df872e8f21cc12d9957011a2294dd0.svg";
export { ForwardRef as ReactComponent };